import styled from "styled-components";

export const Section = styled.div`
	margin: 10px 0;
`;
